import moment from 'moment';

// Lead Priority Pie Chart
export const leadPriorityChartConfig = () => ({
  series: [44, 55, 13, 43],
  pieCharts: {
    chart: {
      width: 450,
      type: 'pie'
    },
    labels: ['Inpipeline', 'Follow Up', 'Schedule Service', 'Conversation'],
    colors: ['#28a745', '#6fcf97', '#ffc107', '#dc3545'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: { width: 275 },
        legend: { position: 'right' }
      }
    }]
  }
});

// Exhibition Wise Chart
export const exhibitionChartConfig = () => ({
  series: [{ name: 'Leads', data: [] }],
  chartOptions: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '70%',
        borderRadius: 0
      }
    },
    colors: ['#FF9F43'],
    dataLabels: {
      enabled: true,
      style: { colors: ['#000'] }
    },
    xaxis: { categories: [], title: { text: '' } },
    yaxis: { title: { text: '' } },
    grid: { strokeDashArray: 4 }
  }
});

// Funnel Chart - FIXED: Remove function reference that loses context
export const funnelChartConfig = () => ({
  series: [{ name: 'Leads', data: [] }],
  funnelRealValues: [],
  stagesCharts: {
    chart: {
      type: 'bar',
      height: 420,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        barHeight: '25%',
        isFunnel: true
      }
    },
    colors: ['#4A00E5', '#1ECBE2', '#FF9D0A', '#00918E', '#5CB85C', '#FC0027'],
    dataLabels: {
      enabled: true,
      // We'll handle this in the component instead
    },
    xaxis: { categories: [] },
    legend: { show: false }
  }
});

// Contact Report Chart
export const contactReportChartConfig = () => ({
  series: [{ name: 'Leads', data: [] }],
  reportCharts: {
    chart: {
      height: 273,
      type: 'bar',
      zoom: { enabled: false },
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        columnWidth: '45%',
        borderRadius: 4,
        distributed: false
      }
    },
    colors: ['#4A00E5'],
    dataLabels: { enabled: false },
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]
    },
    yaxis: {
      min: 10,
      max: 300,
      tickAmount: 5
    },
    grid: { strokeDashArray: 4 },
    legend: { show: false }
  }
});

// Employee Wise Chart
export const employeeWiseChartConfig = () => ({
  series: [{ name: 'Leads', data: [] }],
  chartOptions: {
    chart: {
      type: 'bar',
      height: 350,
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: '70%',
        borderRadius: 0
      }
    },
    colors: ['#26CECC'],
    dataLabels: {
      enabled: true,
      style: { colors: ['#000'] }
    },
    xaxis: { categories: [], title: { text: '' } },
    yaxis: { title: { text: '' } },
    grid: { strokeDashArray: 4 }
  }
});

// Multi Line Chart
export const multiLineChartConfig = () => ({
  series: [
    { name: 'Leads', data: [] },
    { name: 'Closed', data: [] },
    { name: 'Lost', data: [] }
  ],
  chartOptions: {
    chart: {
      type: 'line',
      height: 320,
      toolbar: { show: false }
    },
    stroke: {
      width: 3,
      curve: 'smooth'
    },
    markers: { size: 4 },
    colors: ['#4A00E5', '#28C76F', '#EA5455'],
    xaxis: {
      categories: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]
    },
    yaxis: { title: { text: 'Count' } },
    legend: {
      position: 'top',
      horizontalAlign: 'left'
    },
    grid: { strokeDashArray: 4 },
    tooltip: {
      shared: true,
      intersect: false
    }
  }
});